import { Mcu } from "../../types/mcu";
import Api from "../api";

export default async function apiGetMcu(id: string) {
  return await Api.get<Mcu>({
    input: `/api/v1/mcu/${id}`,
  });
}
